<template>
  <div class="news__cart">
    <div class="news__header">
      <div class="news__title" v-html="escape(title)"></div>
      <date-time class="news__time-date" :value="publicationDate"></date-time>
    </div>
    <div class="news__body">
      <div class="news__text" v-html="escape(briefDescription)">
      </div>
    </div>
    <div class="news__body" v-if="from || to">
      <div class="news__text" >
          Отображать на главной с <date-time tag="span" :value="from" :tz="false"></date-time> по <date-time tag="span" :value="to" :tz="false"></date-time>
      </div>
    </div>
    <div class="news__footer">
      <router-link class="news__footer-more-link gui-btn gui-btn--red gui-btn--w-150"
                   :to="{name: 'news-overview', params: { id }}">
        {{$t('form.news.more-details')}}
      </router-link>
      <div class="news__footer-editing a-display-none">
        <button class="gui-btn gui-btn--white-border gui-btn--w-177 ">{{$t('buttons.modify')}}</button>
        <button class="gui-btn gui-btn--white-border  ">{{$t('form.news.to-archive')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      id: [String, Number],
      title: String,
      publicationDate: Date,
      briefDescription: String,
      from: Date,
      to: Date
    }
  }
</script>

<style scoped>

</style>
